import { createRootRoute, createRoute, createRouter, lazyRouteComponent } from '@tanstack/react-router';
import { AppShell } from './AppShell';
import { TodayPage } from '../routes/TodayPage';

const rootRoute = createRootRoute({
  component: AppShell,
  notFoundComponent: () => <div className="page state-page"><h1>Route not found</h1><a href="/">Return home</a></div>
});

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: TodayPage });
const atlasRoute = createRoute({ getParentRoute: () => rootRoute, path: '/atlas', component: lazyRouteComponent(() => import('../routes/AtlasPage'), 'AtlasPage') });
const moduleRoute = createRoute({ getParentRoute: () => rootRoute, path: '/atlas/$moduleId', component: lazyRouteComponent(() => import('../routes/ModuleHubPage'), 'ModuleHubPage') });
const labsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/learn', component: lazyRouteComponent(() => import('../routes/LabsIndexPage'), 'LabsIndexPage') });
const lessonRoute = createRoute({ getParentRoute: () => rootRoute, path: '/learn/$moduleId/$lessonId', component: lazyRouteComponent(() => import('../routes/LessonPage'), 'LessonPage') });
const referenceRoute = createRoute({ getParentRoute: () => rootRoute, path: '/reference/$moduleId/$atomId', component: lazyRouteComponent(() => import('../routes/ReferencePage'), 'ReferencePage') });
const practiceRoute = createRoute({ getParentRoute: () => rootRoute, path: '/practice', component: lazyRouteComponent(() => import('../routes/PracticePage'), 'PracticePage') });
const problemRoute = createRoute({ getParentRoute: () => rootRoute, path: '/practice/$problemId', component: lazyRouteComponent(() => import('../routes/ProblemWorkspacePage'), 'ProblemWorkspacePage') });
const reviewRoute = createRoute({ getParentRoute: () => rootRoute, path: '/review', component: lazyRouteComponent(() => import('../routes/ReviewPage'), 'ReviewPage') });
const setRoute = createRoute({ getParentRoute: () => rootRoute, path: '/atlas/$moduleId/sets/$setId', component: lazyRouteComponent(() => import('../routes/FollowupPage'), 'FollowupPage') });
const playbookRoute = createRoute({ getParentRoute: () => rootRoute, path: '/playbook', component: lazyRouteComponent(() => import('../routes/PlaybookPage'), 'PlaybookPage') });
const notesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/notes', component: lazyRouteComponent(() => import('../routes/NoteLibraryPage'), 'NoteLibraryPage') });
const settingsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/settings', component: lazyRouteComponent(() => import('../routes/SettingsPage'), 'SettingsPage') });

const routeTree = rootRoute.addChildren([
  indexRoute,
  atlasRoute,
  moduleRoute,
  labsRoute,
  lessonRoute,
  referenceRoute,
  practiceRoute,
  problemRoute,
  reviewRoute,
  setRoute,
  playbookRoute,
  notesRoute,
  settingsRoute
]);

export const router = createRouter({ routeTree, defaultPreload: 'intent', scrollRestoration: true });

declare module '@tanstack/react-router' {
  interface Register { router: typeof router }
}
